// GetCustomer returns the customer data for the given customer session. A valid CO session is required to get this data.
export const CustomerService_GetCustomerLazy = () =>
  import("./service.grpc").then((m) => m.CustomerService_GetCustomer);
CustomerService_GetCustomerLazy.method =
  "aysa_api.services.customer.CustomerService/GetCustomer" as const;
